import Vue from 'vue'
import VueRouter from 'vue-router'

const HomePage = () => import('../views/homePage/index.vue')
const NewsCenter = () => import('../views/newsCenter/index.vue')
const ProjectCenter = () => import('../views/projectCenter/index.vue')
const BiddingHall = () => import('../views/biddingHall/index.vue')
const ProjectAnn = () => import('../views/projectAnn/index.vue')
const Regulation = () => import('../views/regulation/index.vue')
const ContactUs = () => import('../views/contactUs/index.vue')
const NewsDetail = () => import('../views/newsCenter/detail.vue')
const RegulationDetail = () => import('../views/regulation/detail.vue')
const NoticeDetail = () => import('../views/contactUs/detail.vue')

// 1. 安装插件
Vue.use(VueRouter)

// 2. 创建路由对象
const routes = [

  {
    path: '',
    redirect: '/homePage'
  },
  {
    path: '/homePage',
    name: 'homePage',
    component: HomePage
  },
  {
    path: '/newsCenter',
    name: 'newsCenter',
    component: NewsCenter
  },
  {
    path: '/projectCenter',
    name: 'projectCenter',
    component: ProjectCenter
  },
  {
    path: '/projectCenterInfo',
    name: 'projectCenterInfo',
    component: () => import('../views/projectCenter/info.vue'),
  },
  {
    path: '/biddingHall',
    name: 'biddingHall',
    component: BiddingHall,
    beforeEnter () {
      window.open('http://121.36.224.212:8019/login?redirect=%2Findex')
      // window.open('http://81.71.76.218:8019/login')
    }
  },
  {
    path: '/projectAnn',
    name: 'projectAnn',
    component: ProjectAnn
  },
  ,
  {
    path: '/projectAnnInfo',
    name: 'projectAnnInfo',
    component: () => import('../views/projectAnn/info.vue'),
  },
  {
    path: '/regulation',
    name: 'regulation',
    component: Regulation
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: ContactUs
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: NewsDetail
  },
	{
	  path: '/regulationDetail',
	  name: 'regulationDetail',
	  component: RegulationDetail
	},
	{
	  path: '/noticeDetail',
	  name: 'noticeDetail',
	  component: NoticeDetail
  },
  {
	  path: '/documentFile',
	  name: 'documentFile',
	  component: () => import('../views/documentFile/index.vue')
  },
  {
	  path: '/documentFile/fileList',
	  name: 'documentFileList',
	  component: () => import('../views/documentFile/fileList.vue')
  },
  {
	  path: '/projectCenter/bid',
	  name: 'projectCenterBid',
	  component: () => import('../views/projectCenter/bid.vue')
  },
  {
	  path: '/projectAnn/bid',
	  name: 'projectAnnBid',
	  component: () => import('../views/projectAnn/bid.vue')
	},
]
const router = new VueRouter({
  routes,
  mode: 'history'
})

// 3. 导出router
export default router

